import React from "react"; 
import { Link } from "react-router-dom";
import { HashLink } from 'react-router-hash-link';

const Header = () => {
  return <nav>
    <h1 className="AH1">The Boys</h1>
    <main className="main3">
      <HashLink to={"/#home"}>Home</HashLink>
      <Link to={"/Contact"}>Contact</Link>
      <HashLink to={"/#About"}>About</HashLink>
      <HashLink to={"/#Brands"}>Brands</HashLink>
      <Link to={"/Services"}>Services</Link>
    </main>
  </nav>

};

export default Header;